// What a deal document is (TX-US-0043), chosen in the file's own row: for a file waiting to
// upload, or by its uploader for a document already on the deal. Labelled for a screen reader by
// the file it types.

import { DOCUMENT_TYPES } from './documentTypes.js';

export default function DocumentTypeSelect({ label, value, onChange, disabled = false }) {
  return (
    <select className="document-type" value={value} aria-label={label} disabled={disabled}
            onChange={(event) => onChange(event.target.value)}>
      {DOCUMENT_TYPES.map((type) => (
        <option key={type.code} value={type.code}>{type.label}</option>
      ))}
    </select>
  );
}
